"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_FONT_SIZE_MULTIPLIER = exports.ANDROID_VALIDATION_ICON_CONTAINER_OFFSET = exports.ANDROID_HORIZONTAL_PADDING_OFFSET = exports.ANDROID_DEFAULT_PADDING = exports.ALLOW_FONT_SCALING = exports.ADJUSTS_FONT_SIZE_TO_FIT = void 0;
// Because Android
const ANDROID_VALIDATION_ICON_CONTAINER_OFFSET = exports.ANDROID_VALIDATION_ICON_CONTAINER_OFFSET = 5;
const ANDROID_HORIZONTAL_PADDING_OFFSET = exports.ANDROID_HORIZONTAL_PADDING_OFFSET = 8;
const ANDROID_DEFAULT_PADDING = exports.ANDROID_DEFAULT_PADDING = 0;
const ALLOW_FONT_SCALING = exports.ALLOW_FONT_SCALING = true;
const ADJUSTS_FONT_SIZE_TO_FIT = exports.ADJUSTS_FONT_SIZE_TO_FIT = true;
const MAX_FONT_SIZE_MULTIPLIER = exports.MAX_FONT_SIZE_MULTIPLIER = 3;